module.exports = __webpack_public_path__ + "img/keyboard-01.ee47ea86.svg";